import { render, staticRenderFns } from "./UsersNewPage.vue?vue&type=template&id=06e75b8f&scoped=true"
import script from "./UsersNewPage.vue?vue&type=script&lang=js"
export * from "./UsersNewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e75b8f",
  null
  
)

export default component.exports